import { cn } from "../lib/utils";

export const ShortcutKey = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "px-[4px] py-[2px] rounded-[4px] border-neutral-100 border-[1px] inline-block bg-white",
        className
      )}
    >
      {children}
    </div>
  );
};
